// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pIO1","type":"styles_type__3ztV2","choices":"styles_choices__1QrBl"};